import { render } from "./ConfirmationAlert.vue?vue&type=template&id=34f7bee9&ts=true"
import script from "./ConfirmationAlert.vue?vue&type=script&lang=ts"
export * from "./ConfirmationAlert.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__